import { FeatureFlag } from '@ps/web-core-enums';
import type { Modal } from '@ps/web-core-store';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MemoryRouter, Route } from 'react-router';

import useFeature from '@swf/core/hooks/useFeature';
import useInactivityTimeout from '@swf/core/hooks/useInactivityTimeout';
import { select } from '@swf/core/store';
import { FirstLoader, InactivityTimeoutPrompt, SignupWizard } from '@swf/first';

import ModalRoute from './ModalRoute';

const SignupRoute: React.FC = () => {
  const SWCSignup = useFeature(FeatureFlag.SwcSignup);
  const bankID = useFeature(FeatureFlag.BankID);
  const signupPath = `/auth/registration${bankID ? '/bankid' : ''}`;
  const hasClientSession = useSelector(select.session.hasClientSession);
  const query = useSelector(select.location.getQuery);
  const { mitid } = query;
  const [loading, setLoading] = useState(!!mitid);
  const { path, locationState } = (useSelector(select.modal.getCurrent) || {}) as Partial<Modal>;
  const { showInactivityPrompt, remainingSeconds, setShowInactivityPrompt } =
    useInactivityTimeout();

  useEffect(() => {
    if (hasClientSession) setLoading(false);
  }, [hasClientSession]);

  return SWCSignup ? (
    <MemoryRouter
      keyLength={process.env.NODE_ENV === 'test' ? 0 : 6}
      initialEntries={[{ pathname: path, state: locationState }]}
    >
      {showInactivityPrompt && (
        <Route
          render={() => (
            <InactivityTimeoutPrompt
              remainingSeconds={remainingSeconds}
              onClose={() => setShowInactivityPrompt(false)}
            />
          )}
        />
      )}
      {loading ? <FirstLoader /> : React.createElement(SignupWizard)}
    </MemoryRouter>
  ) : (
    <ModalRoute modal={{ path: signupPath }} />
  );
};

export default SignupRoute;
